import makeVolume from './k-volume';
import makeCandle from './k-candle';
import makeKdj from './k-kdj';
import makeMacd from './k-macd';

export default {
    makeCandle: () => makeCandle,
    makeVolume: () => makeVolume,
    makeKdj: () => makeKdj,
    makeMacd: () => makeMacd
}
